import classnames from 'classnames';
import * as React from 'react';

type IHelpBlockProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>;

/**
 * HelpBlock should be used in a FormGroup to show help text for that FormGroup
 */
export const HelpBlock: React.FunctionComponent<IHelpBlockProps> = ({ className, ...restProps }) => (
  <span className={classnames('help-block')} {...restProps} />
);
